/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Alledokumentevorgelegt2Inputs */



/**

* @param {_Field_Alledokumentevorgelegt2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_alledokumentevorgelegt2 = /** @type {((inputs?: _Field_Alledokumentevorgelegt2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Alledokumentevorgelegt2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Alle Dokumente vorgelegt")
});
export { _field_alledokumentevorgelegt2 as "_field_alleDokumenteVorgelegt" }